// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Cn from "rescript-classnames/src/Cn.bs.js";
import * as Util from "../../common/util.bs.js";
import * as Curry from "@rescript/std/lib/es6/curry.js";
import * as Button from "./Button.bs.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as ReactFontawesome from "@fortawesome/react-fontawesome";

function visibilityContainer(v) {
  return Cn.make([v ? "visible animate__animated animate__fadeIn animate__faster" : "invisible"]);
}

function visibilityModal(v) {
  return Cn.make([v ? "visible animate__animated animate__fadeIn animate__faster" : "invisible"]);
}

function ModalWithButton(props) {
  var visible = props.visible;
  var onButtonClick = props.onButtonClick;
  return JsxRuntime.jsx("div", {
              children: JsxRuntime.jsx("div", {
                    children: JsxRuntime.jsxs("div", {
                          children: [
                            JsxRuntime.jsx("h2", {
                                  children: Util.ReactStuff.s(props.heading),
                                  className: "text-2xl text-center font-black md:leading-loose text-dark-gray"
                                }),
                            JsxRuntime.jsx("p", {
                                  children: Util.ReactStuff.s(props.text),
                                  className: "text-sm md:text-base leading-normal font-thin mt-8 mb-10 text-center"
                                }),
                            JsxRuntime.jsx("div", {
                                  children: JsxRuntime.jsx("button", {
                                        children: Util.ReactStuff.s(props.button),
                                        className: Cn.make([
                                              Button.primaryStyle,
                                              "w-24 text-base md:w-32 h-10 md:h-12 mr-3 md:text-lg font-bold"
                                            ]),
                                        onClick: (function (e) {
                                            e.preventDefault();
                                            Curry._1(onButtonClick, undefined);
                                          })
                                      }),
                                  className: "inline-flex justify-center"
                                }),
                            JsxRuntime.jsx("span", {
                                  children: JsxRuntime.jsx(ReactFontawesome.FontAwesomeIcon, {
                                        icon: [
                                          "fas",
                                          "times"
                                        ]
                                      }),
                                  className: "absolute flex items-center justify-center -mt-3 -mr-3 right-0 top-0 h-8 w-8 overflow-visible rounded-full bg-prezzee-red fill-current text-white cursor-pointer",
                                  onClick: (function (e) {
                                      e.preventDefault();
                                      Curry._1(onButtonClick, undefined);
                                    })
                                })
                          ],
                          className: Cn.make([
                                "text-gray-800 fixed shadow-inner max-w-md relative bottom-0 inset-x-0 m-auto px-4 py-8 bg-white w-10/12 md:w-full flex flex-col rounded-md",
                                visibilityModal(visible)
                              ]),
                          onClick: (function (e) {
                              e.preventDefault();
                            })
                        }),
                    className: Cn.make([
                          "fixed inset-0 flex bg-smoke-light",
                          visibilityContainer(visible)
                        ]),
                    style: {
                      zIndex: "1000"
                    }
                  })
            });
}

var make = ModalWithButton;

export {
  visibilityContainer ,
  visibilityModal ,
  make ,
}
/* Util Not a pure module */
